
export enum InfoShowType{
     LOG,
     NOTIFICATION,
     TOAST
 }
